<template src='./index.html'></template>
<script>
import minhead from '@/components/common/minHead/index.vue';
import oinvDetail from "./oinvDetail/index.vue";
import iinvDetail from "./iinvDetail/index.vue";
import summaryList from "./summaryList/index.vue";
import applyList from './applyList/index.vue';
export default {
  components: {
    minhead,
    oinvDetail,
    iinvDetail,
      summaryList,
      applyList,
  },
  props: {
    previewManuscriptId: {
      type: Number,
      default: -1
    }
  },
  data: function () {
    return {
      chooseindex: 0,
      taballData: [
        {
          label: "销项税额明细表"
        },
        {
          label: "进项税额明细表"
        },
        {
          label: "汇总表"
        },
        {
          label: "申请表"
        },
      ],
    };
  },
  created() {
  },
  methods: {
	  chooseindexs(e){
		  this.chooseindex = e
	  },
    forback() {
      this.$emit('previewManuscriptForback');
    }
  }
};
</script>


<style scoped lang="less">
</style>
